import { createSlice } from "@reduxjs/toolkit";
import { cableSubscriptions } from "./api";

const initialState = {
  response: {},
  loading: false,
  error: null,
};

const cableSubscriptionSlice = createSlice({
  name: "cableSubscriptions",
  initialState,

  reducers: {
    clearCableSubscriptions: () => initialState,
  },

  extraReducers: (builder) => {
    builder.addCase(cableSubscriptions.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(cableSubscriptions.fulfilled, (state, action) => {
      state.response = action.payload;
      state.loading = false;
    });

    builder.addCase(cableSubscriptions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { clearCableSubscriptions } = cableSubscriptionSlice.actions;

export default cableSubscriptionSlice.reducer;
